"use client";

import { useState } from "react";
import { DragScroll } from "@/components/about/DragScroll";
import type { ProjectImage } from "@/lib/types";
import { BlurImage } from "@/components/ui/BlurImage";

/**
 * Full-bleed careers process gallery (big.dk): one slide at a time,
 * drag with snap, counter `01 - 04` bottom-right.
 */
export function ProcessCarousel({ images }: { images: ProjectImage[] }) {
  const [index, setIndex] = useState(0);
  const total = images.length;
  if (total === 0) return null;

  const pad = (n: number) => String(n).padStart(2, "0");

  return (
    <div className="overflow-hidden px-7 md:px-[70px] lg:px-[100px] xl:px-[130px]">
      <DragScroll
        className="overflow-hidden"
        trackClassName="flex cursor-grab flex-nowrap gap-5 active:cursor-grabbing"
        snap
        slideCount={total}
        onIndexChange={setIndex}
        showEndSpacer={false}
      >
        {images.map((img, i) => (
          <BlurImage
            key={`${img.url}-${i}`}
            src={img.url}
            alt={img.alt || ""}
            loading={i === 0 ? "eager" : "lazy"}
            fetchPriority={i === 0 ? "high" : "auto"}
            width={img.width}
            height={img.height}
            blurDataUrl={img.blurDataUrl}
            draggable={false}
            wrapperClassName="flex-[0_0_100%]"
            className="drag-none select-none"
          />
        ))}
      </DragScroll>
      <div className="mt-3 text-right">
        {pad(index + 1)} - {pad(total)}
      </div>
    </div>
  );
}
